<template>
    <div
        class="produkt-img-container relative inset-0 flex items-center justify-center"
    >
        <img
            class="img-fluid"
            :src="
                $utils.screenRatio() +
                    '/img/product/softline76/softline76-ad.png'
            "
        />
        <div class="absolute" style="z-index: 1">
            <img
                class="img-fluid"
                :src="
                    $utils.screenRatio() +
                        '/img/product/softline76/softline76-ad-linien.png'
                "
            />
            <div id="softline76ad-point1" class="softline76ad-hover-point-left">
                <span>
                    <strong>Verglasungsstärken</strong><br />
                    von 18 bis 48 mm
                </span>
            </div>
            <div
                id="softline76ad-point2"
                class="softline76ad-hover-point-right"
            >
                <span>
                    <strong>Vielfältige Designoptionen:</strong><br />
                    VEKA SPECTRAL, Folien und Vorsatzschalen möglich
                </span>
            </div>
            <div id="softline76ad-point3" class="softline76ad-hover-point-left">
                <span>
                    <strong>Glasfalzhöhe </strong><br />
                    von 28 mm reduziert Wärmebrücken
                </span>
            </div>
            <div
                id="softline76ad-point4"
                class="softline76ad-hover-point-right"
            >
                <span>
                    <strong>Zwei Dichtungsebene</strong><br />
                    als Schutz gegen Lärm, Kälte, Feuchtigkeit und Zugluf
                </span>
            </div>
            <div id="softline76ad-point5" class="softline76ad-hover-point-left">
                <span>
                    <strong>Dämmwerte</strong><br />
                    von bis zu U<sub>w</sub> = 0,79 W/(m²K)* bei Einsatz von
                    hochisolierender Dreifachverglasung mit U<sub>g</sub> = 0,4
                    W/(m²K)
                    <small class="mt-4">
                        *mit U<sub>f</sub> = 1,2 W/(m²K), U<sub>g</sub> = 0,4
                        W/(m²K), ψ<sub>g</sub> = 0,035 W/(mK)
                    </small>
                </span>
            </div>
            <div
                id="softline76ad-point6"
                class="softline76ad-hover-point-right"
            >
                <span>
                    <strong>VEKA-Qualität:<br />Klasse A</strong><br />
                    mit Wandstärken nach DIN EN 12608
                </span>
            </div>
            <div
                id="softline76ad-point7"
                class="softline76ad-hover-point-right"
            >
                <span>
                    <strong>Mehrkammer-System</strong><br />
                    mit 76 mm Basis-Bautiefe für hervorragende Wärmedämmung,
                    universell einsetzbar für Neubau und Renovierung
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Softline76ad'
};
</script>

<style>
.produkt-img-container {
    position: relative;
    max-width: 492px;
    margin: 0 auto;
    display: block;
}

.softline76ad-hover-point-left {
    position: absolute;
    background: url('/../img/icon/pluspunkt.png') no-repeat;
    width: 100px;
    height: 100px;
    background-position: top right;
}

.softline76ad-hover-point-right {
    position: absolute;
    background: url('/../img/icon/pluspunkt.png') no-repeat;
    width: 100px;
    height: 100px;
    background-position: top left;
}

.softline76ad-hover-point-left > span,
.softline76ad-hover-point-right > span {
    display: none;
    position: absolute;
    width: 200px;
    color: #ffffff;
    font-size: 17px;
    line-height: 20px;
    padding: 10px;
}

.softline76ad-hover-point-left sub {
    font-size: 75% !important;
}

.softline76ad-hover-point-left > span *,
.softline76ad-hover-point-right > span * {
    color: #ffffff;
    font-size: 17px;
    line-height: 20px;
}

.softline76ad-hover-point-left > span small,
.softline76ad-hover-point-right > span small {
    color: #ffffff;
    display: inline-block;
    font-size: 0.6em;
    line-height: 1.2em;
    text-align: right;
}

.softline76ad-hover-point-left > span {
    right: 0;
    text-align: right;
}
.softline76ad-hover-point-right > span {
    left: 0;
    text-align: left;
}

.softline76ad-hover-point-left:hover,
.softline76ad-hover-point-right:hover {
    background: none;
}

.softline76ad-hover-point-left:hover > span,
.softline76ad-hover-point-right:hover > span {
    display: block;
    cursor: none;
    background: rgba(0, 0, 0, 0.2);
}

#softline76ad-point5 > span {
    width: 270px;
}

#softline76ad-point1,
#softline76ad-point3,
#softline76ad-point5 {
    left: -30px;
}
#softline76ad-point2,
#softline76ad-point4,
#softline76ad-point6 {
    right: -25px;
}
#softline76ad-point7 {
    bottom: -100px;
}

#softline76ad-point1 {
    top: 156px;
}

#softline76ad-point2 {
    top: 150px;
}

#softline76ad-point3 {
    bottom: 132px;
}

#softline76ad-point4 {
    bottom: 95px;
}

#softline76ad-point5 {
    bottom: -3px;
}

#softline76ad-point6 {
    bottom: -3px;
}

#softline76ad-point7 {
    left: 205px;
}
</style>
